<button
  [matMenuTriggerData]="userMenuData"
  [matMenuTriggerFor]="menu"
  (click)="toggleDropdown()"
>
  <ng-container *ngIf="problem">{{ problem?.problem }} </ng-container>
  <ng-container *ngIf="!problem">选择问题</ng-container>
  <img alt="arrow" width="20" height="20" [src]="src" />
</button>
<mat-menu #menu="matMenu" class="my-menu">
  <ng-template matMenuContent let-menuWidth="menuWidth">
    <div [style.width.px]="menuWidth">
      <button mat-menu-item *ngIf="problems.length === 0">
        <ng-container *ngIf="platform">没有数据</ng-container>
        <ng-container *ngIf="!platform">请先选择您的车票</ng-container>
      </button>
      <button
        mat-menu-item
        *ngFor="let data of problems"
        (click)="selectOption(data)"
      >
        <span>{{ data.problem }}</span>
      </button>
    </div>
  </ng-template>
</mat-menu>
